import { render } from "./AddonClasphoto.vue?vue&type=template&id=3e319000&scoped=true"
import script from "./AddonClasphoto.vue?vue&type=script&lang=js"
export * from "./AddonClasphoto.vue?vue&type=script&lang=js"

import "./AddonClasphoto.vue?vue&type=style&index=0&id=3e319000&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e319000"]])

export default __exports__